var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBigIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2083 54.75V66.2049L19.8164 63.44L34.3009 54.75H48.6666C52.0216 54.75 54.75 52.0216 54.75 48.6667V24.3333C54.75 20.9784 52.0216 18.25 48.6666 18.25H12.1666C8.81169 18.25 6.08331 20.9784 6.08331 24.3333V48.6667C6.08331 52.0216 8.81169 54.75 12.1666 54.75H15.2083ZM12.1666 24.3333H48.6666V48.6667H32.6158L21.2916 55.4617V48.6667H12.1666V24.3333Z",
    fill: "#51CA64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8333 6.08398H24.3333C20.9784 6.08398 18.25 8.81236 18.25 12.1673H54.75C58.105 12.1673 60.8333 14.8957 60.8333 18.2507V42.584C64.1883 42.584 66.9167 39.8556 66.9167 36.5007V12.1673C66.9167 8.81236 64.1883 6.08398 60.8333 6.08398Z",
    fill: "#51CA64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBigIcon);
export default __webpack_public_path__ + "static/media/chat_big_icon.0692a51cc32416ece15e08d3bf7e15cc.svg";
export { ForwardRef as ReactComponent };